<template>
  <div>
    <div v-if="showBindMember">
      <van-col v-if="wxLoginInfo.HeadImgUrl !== ''" :span="24" style="text-align: center;">
        <img :src="wxLoginInfo.HeadImgUrl" style="width: 132px; height: 132px;" />
      </van-col>
      <van-form validate-first @submit="handleBindMember">
        <van-col :span="24">
          <base-input v-model="form.mobile" type="digit" size="large" label="手机号"
                      maxlength="11" :rules="[{ validator: validMobile, message: '手机号输入有误' }]"
          />
        </van-col>
        <van-col :span="24">
          <base-input v-model="form.code" type="digit" size="large" label="短信验证码"
                      maxlength="6" :rules="[{ validator: validSms, message: '短信验证码输入有误' }]"
          >
            <template #button>
              <van-button size="small" type="primary" :disabled="!isMobileValid"
                          @click="handleSendSms">{{ countdownMsg }}</van-button>
            </template>
          </base-input>
        </van-col>
        <van-col :span="24" style="text-align: center; color: #c3c3c3">
          <span>您好，请先绑定会员身份！</span>
        </van-col>
        <van-col :span="22" :offset="1">
          <br>
          <base-button size="large" native-type="submit" :round="true">绑 定</base-button>
        </van-col>
      </van-form>
    </div>
    <div v-else style="margin-top: 30px;">
      <van-col :span="6" style="text-align: right;">
        <van-icon name="checked" size="26" color="#13ce66" />
      </van-col>
      <van-col :span="18" style="text-align: left;">
        <span style="font-size: 18px; color: #13ce66; padding-left: 10px;">您已成功绑定会员身份！</span>
      </van-col>
      <van-col :span="24" style="font-size: 14px; text-align: center; color: #c3c3c3">
        可从服务号中【服务中心】-【三方订单】进入订单信息。
      </van-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { sendSms, bindMember } from '@/api/wx-fwh'
export default {
  name: 'WxLogin',
  data() {
    return {
      showBindMember: false,
      wxLoginInfo: null,
      form: {
        mobile: '',
        code: '',
        wx_id: ''
      },
      countdown: this.CONST.SEND_SMS_INTERVAL,
      countdownMsg: '获取验证码'
    }
  },
  computed: {
    ...mapGetters(['token', 'userInfo']),
    isMobileValid() {
      return this.form.mobile && /1\d{10}/.test(this.form.mobile) &&
        this.countdownMsg === '获取验证码'
    }
  },
  created() {
    if (this.token && this.userInfo) {
      this.$router.push('/wx-sell-order-list')
    } else {
      const data = localStorage.getItem('wxLoginInfo')
      if (data) {
        this.wxLoginInfo = JSON.parse(data)
        this.form.wx_id = this.wxLoginInfo.UnionId
        localStorage.removeItem('wxLoginInfo')
        this.showBindMember = true
      } else {
        this.alert('获取身份失败，请您重新从微信服务号进入')
      }
    }
  },
  methods: {
    validMobile(val) {
      return /1\d{10}/.test(val)
    },
    validSms(val) {
      return /\d{6}/.test(val)
    },
    handleSendSms() {
      sendSms({ mobile: this.form.mobile }).then(resp => {
        if (resp.success) {
          this.alert(resp.msg)
          const timer = setInterval(() => {
            if (this.countdown === 0) {
              clearInterval(timer)
              this.countdown = this.CONST.SEND_SMS_INTERVAL
              this.countdownMsg = '获取验证码'
            } else {
              this.countdownMsg = `重新发送(${this.countdown})`
              this.countdown = this.countdown - 1
            }
          }, 1000);
        } else {
          this.alert(resp.msg)
        }
      })
    },
    handleBindMember() {
      bindMember(this.form).then(resp => {
        if (resp.success) {
          this.alert(resp.msg)
          this.showBindMember = false
        } else {
          this.alert(resp.msg)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/wxfwh/wx-login.vue